import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { throwError } from 'rxjs';
import { environment } from './../../environments/environment';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { GlobalService } from '../core/global.service';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
};
var PropertyService = /** @class */ (function () {
    function PropertyService(_http, _global) {
        this._http = _http;
        this._global = _global;
    }
    PropertyService.prototype.getRecentProperties = function () {
        var api = _GlobalNS.api.property.recentProperties;
        var url = "" + api;
        return this._http.get(url);
    };
    PropertyService.prototype.getPropertyActivityMenuItems = function (propertyId) {
        var _this = this;
        var items = [{ id: '1' }, { id: '2' }];
        items.map(function (i) {
            i.label = (i.id === '1') ? 'Open in New Window' : 'Open Property';
            i.url = _this.getPropertyViewUri(propertyId);
            i.target = (i.id === '1') ? '_blank' : '_self';
        });
        return items;
    };
    PropertyService.prototype.getPropertyViewUri = function (propertyId) {
        var api = _GlobalNS.routes.property.viewTasks;
        var buildUri = api + "&property_id=" + propertyId;
        return buildUri;
    };
    PropertyService.prototype.getFavoritePropertiesSearchUri = function () {
        var api = _GlobalNS.routes.property.search;
        var favPropertiesSearchUri = api + "&FavoritesOnly=1";
        return favPropertiesSearchUri;
    };
    PropertyService.prototype.getDataPropertyById = function () {
        var api = _GlobalNS.api.property.header;
        var propertyId = this._global.find(_GlobalNS.paths.PropertyId);
        var url = (environment.production) ? api + "&PropertyId=" + propertyId : api + "?PropertyId=1";
        return this._http.get(url);
    };
    /*
    Get Property HeaderSummary DataPoints
    */
    PropertyService.prototype.HeaderSummary = function (source, strategy) {
        var api = _GlobalNS.api.property.header;
        var propertyId = this._global.find(_GlobalNS.paths.PropertyId);
        var params = new HttpParams()
            .set('propertyId', propertyId.toString())
            .set('source', source)
            .set('displayArea', strategy);
        return this._http.get("" + api, { params: params }).pipe(catchError(function (err) {
            return throwError(err);
        }));
    };
    PropertyService.ngInjectableDef = i0.defineInjectable({ factory: function PropertyService_Factory() { return new PropertyService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: PropertyService, providedIn: "root" });
    return PropertyService;
}());
export { PropertyService };
